const W6_SIZE_GUIDE_SELECTOR = '[data-w6-size-guide-link]';

/** Add small accessibility enhancements without replacing Horizon behavior. */
function enhanceProductPage(root = document) {
  const product = root.querySelector('[data-testid="product-information"]');
  if (!(product instanceof HTMLElement)) return;

  // Give gallery thumbnails a useful accessible name when an app or imported
  // product image did not provide one.
  product.querySelectorAll('slideshow-controls[thumbnails] button, slideshow-controls[thumbnails] [role="button"]').forEach((control, index) => {
    if (!(control instanceof HTMLElement) || control.hasAttribute('aria-label')) return;
    const image = control.querySelector('img');
    const imageAlt = image instanceof HTMLImageElement ? image.alt.trim() : '';
    const controlLabel = imageAlt || `View product image ${index + 1}`;
    control.setAttribute('aria-label', controlLabel);
    // Desktop shoppers receive the same useful description on hover without
    // adding permanent visual clutter to the thumbnail rail.
    if (!control.hasAttribute('title')) control.setAttribute('title', controlLabel);
  });

  // Announce selected variant availability changes to assistive technology.
  const availability = product.querySelector('.w6-availability-note');
  if (availability instanceof HTMLElement) {
    availability.setAttribute('role', 'status');
    availability.setAttribute('aria-live', 'polite');
  }

  // Accordions are easier to understand when the summary owns the content.
  product.querySelectorAll('details').forEach((details, index) => {
    const summary = details.querySelector(':scope > summary');
    if (!(summary instanceof HTMLElement)) return;
    const panel = Array.from(details.children).find((child) => child !== summary);
    if (!(panel instanceof HTMLElement)) return;
    const id = panel.id || `w6-product-panel-${index + 1}`;
    panel.id = id;
    summary.setAttribute('aria-controls', id);
  });
}

if (!window.__watch6ProductUxBound) {
  window.__watch6ProductUxBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(W6_SIZE_GUIDE_SELECTOR);
    if (!(trigger instanceof HTMLAnchorElement)) return;

    const targetSelector = trigger.getAttribute('href');
    if (!targetSelector || !targetSelector.startsWith('#')) return;

    const target = document.querySelector(targetSelector);
    if (!(target instanceof HTMLDetailsElement)) return;

    event.preventDefault();
    target.open = true;

    const summary = target.querySelector(':scope > summary');
    requestAnimationFrame(() => {
      (summary || target).scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (summary instanceof HTMLElement) summary.focus({ preventScroll: true });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceProductPage(), { once: true });
  } else {
    enhanceProductPage();
  }

  // Shopify can replace product HTML after variant/app section rendering.
  document.addEventListener('shopify:section:load', (event) => enhanceProductPage(event.target));
}

